import { FC } from 'react';

import { StyledLink } from './ButtonSuggestionItem.styles';
import { ButtonSuggestionItemProps } from './model';

export const ButtonSuggestionItem: FC<ButtonSuggestionItemProps> = ({ keyword, url, onClick }) => {
    return (
        <StyledLink href={url} onClick={onClick}>
            {keyword}
        </StyledLink>
    );
};
